import { render, staticRenderFns } from "./Rating0To10DashboardItem.vue?vue&type=template&id=1ad3da58"
import script from "./Rating0To10DashboardItem.vue?vue&type=script&lang=js"
export * from "./Rating0To10DashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad3da58')) {
      api.createRecord('1ad3da58', component.options)
    } else {
      api.reload('1ad3da58', component.options)
    }
    module.hot.accept("./Rating0To10DashboardItem.vue?vue&type=template&id=1ad3da58", function () {
      api.rerender('1ad3da58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/Rating0To10DashboardItem.vue"
export default component.exports